export const STATUS_COLOR = {
  DELETED: "red",
  ACTIVE: "green",
} as const;
